import React from 'react'
import { Customers, Carousel } from './../../components'
import { getCustomers } from './../../core/api/customer-provider'
import { Container, Row, Col } from 'react-bootstrap'

const Clientes = () => {

    const [customerData, setCustomerData] = React.useState()

    React.useEffect(() => {
        getCustomers().then((response) => setCustomerData(response.data))
    },[])

    return (
        <>
            {
                customerData && (
                    <>
                    <Carousel slides={customerData.slides}/>
                    <Container fluid>
                        <Row className='my-5'>
                            <Col xs={12} className='px-0'>
                                <Customers
                                    customers={customerData.customers}
                                />
                            </Col>
                        </Row>
                    </Container>
                    </>
                )
            }
        </>
    )
}

export default Clientes